import React, { useState } from "react";
import "../assets/css/Faq.css";

const faqData = [
    {
        question: "What is Aabhyas Mitra?",
        answer:
            "Aabhyas Mitra is an academic support platform designed for 8th, 9th, and 10th standard students. It connects students with trained Educational Counsellors (ECs), structured practice systems, and transparent admission processes."
    },
    {
        question: "Which boards are supported?",
        answer:
            "We currently support SSC, CBSE boards with subject-wise enrollment and curriculum-aligned guidance."
    },
    {
        question: "What is the role of an Educational Counsellor (EC)?",
        answer:
            "An EC guides students through admissions, subject selection, fee management, reminders, and continuous academic follow-ups."
    },
    {
        question: "How does student admission work?",
        answer:
            "Students are enrolled through a digital admission form with OTP verification, document upload, subject selection, and fee confirmation."
    },
    {
        question: "Is online payment available?",
        answer:
            "Yes. Secure online payment gateway integration is available along with automated invoices and fee reminders."
    },
    {
        question: "What is an Aabhyasika?",
        answer:
            "An Aabhyasika is a structured learning center where students practice under guidance. Seat availability and waiting lists are managed digitally."
    },
    {
        question: "Will parents receive updates?",
        answer:
            "Yes. Parents receive notifications, reminders, and important academic updates to maintain transparency."
    },
    {
        question: "Is this platform available as a mobile app?",
        answer:
            "Aabhyas Mitra is accessible via website and progressive web app (PWA), ensuring smooth usage without compulsory app installation."
    }
];

export default function Faq() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="am-faq-section" id='faq'>
            <h2 className="am-faq-title">Frequently Asked Questions</h2>
            <p className="am-faq-subtitle">
                Everything you need to know about Aabhyas Mitra
            </p>

            <div className="am-faq-container">
                {faqData.map((item, index) => (
                    <div
                        key={index}
                        className={`am-faq-item ${activeIndex === index ? "active" : ""
                            }`}
                    >
                        <button
                            className="am-faq-question"
                            onClick={() => toggleFAQ(index)}
                        >
                            {item.question}
                            <span className="am-faq-icon">
                                {activeIndex === index ? "−" : "+"}
                            </span>
                        </button>

                        <div className="am-faq-answer">
                            <p>{item.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
